module.exports = __webpack_public_path__ + "images/category_lp/construction_equipment/store_images/5_b9ea2b0ac0d3d92b1caaf7f74ec42de3.png";